<template>
    <Shouye />
</template>

<script>
  // @ is an alias to /src
  import Shouye from '@/mainhtml/shouye.vue';
  import Test from "./test";

  export default {
    name: 'Home',
    components: {
      Test,
      HelloWorld,
        Shouye,
    }
  }
</script>
